import { render } from "./SlidePreviewImage.vue?vue&type=template&id=4c909070"
import script from "./SlidePreviewImage.vue?vue&type=script&lang=js"
export * from "./SlidePreviewImage.vue?vue&type=script&lang=js"

import "./SlidePreviewImage.vue?vue&type=style&index=0&id=4c909070&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__